export default __webpack_public_path__ + "static/media/before@3x.83873b88.png";